import React from 'react';
import { HeroSection } from './components/HeroSection';
import { CardSection } from './components/CardSection';
import { ClarityTracker } from './components/ClarityTracker';
import { ErrorBoundary } from './components/ErrorBoundary';
export function App() {
  return <ErrorBoundary data-id="element-0">
      <ClarityTracker data-id="element-1" />
      <div className="w-full min-h-full" data-id="element-2">
        <ErrorBoundary data-id="element-3">
          <HeroSection data-id="element-4" />
        </ErrorBoundary>
        <ErrorBoundary data-id="element-5">
          <CardSection data-id="element-6" />
        </ErrorBoundary>
      </div>
    </ErrorBoundary>;
}